module.exports = __webpack_public_path__ + "static/media/Dhanula.3f79be25.jpg";